export const COPY_FEEDBACK_DURATION = 3000;
export const STALE_PEER_THRESHOLD = 60000;
export const FRESH_PEER_THRESHOLD = 30000;
export const PEER_CONNECTION_DELAY = 1500;
export const FALLBACK_CONNECTION_DELAY = 5000;
export const MAX_RETRY_DELAY = 5000;
export const RATE_LIMIT_COOLDOWN = 2000;

// WebRTC connection establishment timeout (45 seconds - matches iOS)
// Increased from 30s to handle slow networks during handshake
export const WEBRTC_CONNECTION_TIMEOUT = 45000;
